import React from 'react';
import { History } from 'history';
import { Input, InputMultiline, InputSelect, InputSwitch, InputPicklist } from '../../components';
import BaseView from '../base/base-view.component'; 
import Model from './transactiontype-model';  //editable..
import AppService from '../../services/app.service';

interface IProps { 
    history: History;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class TransactiontypeView extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
    }

    private onLoad = (data: any) => {
        this.setState({datarow:  data});
    }

    render() {
        return (
            //editable..
            <BaseView history={this.props.history} 
                model={Model} onLoad={this.onLoad}>              
                
                <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} readOnly/>
                <Input name='name' label='Name' value={this.state.datarow.name} readOnly/>
                <InputMultiline name='description' label='Description' value={this.state.datarow.description} readOnly/>
                {AppService.isAppFullVersion() &&
                <InputPicklist name='owner' label='Owner' value={this.state.datarow.owner} readOnly caption={this.state.datarow.ownerCaption} />   
                }
                <InputSelect name='type' label='Type' value={this.state.datarow.type} options={Model.optionType} readOnly/>
                <InputSelect name='pricetype' label='Use Price' value={this.state.datarow.pricetype} options={Model.optionPricetype} readOnly/>
                <InputPicklist name='reportgroup' label='Report Group' value={this.state.datarow.reportgroup} caption={this.state.datarow.reportgroupCaption} readOnly/>
                 
            </BaseView>
        );
    }
}